import * as $modal from './_modal'
import { propertyform as $propertyform } from './search'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
    exportTemplateId: string
}

var options: IInitOptions

export function init($options: IInitOptions): void {
    options = $options

    $('.' + options.pagePrefix + '-continue').click(function () {
        $propertyform.getFile(options.exportTemplateId)
    })

    $('.' + options.pagePrefix + '-cancel').click(function () {
        $modal.hide()
    })
}
